// extracted by mini-css-extract-plugin
export default {"badge":"badge_badge__dVsld","small":"badge_small__0COJk","number":"badge_number__nfM6z"};